import { render, staticRenderFns } from "./OrgIncrementalManager.vue?vue&type=template&id=48aea729&scoped=true"
import script from "./OrgIncrementalManager.vue?vue&type=script&lang=js"
export * from "./OrgIncrementalManager.vue?vue&type=script&lang=js"
import style0 from "./OrgIncrementalManager.vue?vue&type=style&index=0&id=48aea729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aea729",
  null
  
)

export default component.exports